import React, { useState, useContext, useEffect } from "react";
import { Form, ProgressBar, Button, Card, Row, Col, Spinner,Modal } from "react-bootstrap";
import { ScoreContext } from "../ScoreContext";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Menubar from "../Menubar";
import BackgroundFooter from "../BackgroundFooter";
import "../../ComponentsCss/Phishing.css";
import NavigationBar from "../Nav";
import q1 from "../../Assets/q1.png";
import q2 from "../../Assets/q2.png";
import q3 from "../../Assets/q3.png"; 
import q4 from "../../Assets/q4.png"; 
import q5 from "../../Assets/q5.png"; 
import q6 from "../../Assets/q6.png"; 
import slide1 from "../../Assets/Slide1.png";
import slide2 from "../../Assets/Slide2.png";
import slide3 from "../../Assets/Slide3.png";
import slide4 from "../../Assets/Slide4.png";
import slide5 from "../../Assets/Slide5.png";
import generatePhishingReport from "./phishingReportGenerator";
import susanLogo from "../../Assets/srql.png";
import generatePhishingCertificate from "./phishingCertificateGenerator";
import html2canvas from 'html2canvas'; // ✅ Add this




const PhishingAssessmentModule = ({ userData}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false;
  });

  const [currentStep, setCurrentStep] = useState(0); // 0 = intro video, 1 = questions
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  // ✅ DPDP-style Modal States
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [certificatePreviewUrl, setCertificatePreviewUrl] = useState(null);
  const [showLinkedInModal, setShowLinkedInModal] = useState(false);
  const [showCertificateCanvas, setShowCertificateCanvas] = useState(false);


  const [comments, setComments] = useState({});
  const [loadingComments, setLoadingComments] = useState(false);
  const [activeSection, setActiveSection] = useState({});
  const [activeTab, setActiveTab] = useState(null);

  const handleTabClick = (tab) => {
  setActiveTab((prev) => (prev === tab ? null : tab));
};
  const {
    responses,
    fetchResponsesForSection,
    updateResponses,
    saveAllResponsesToBackend,
    updateScore,
    clearResponsesForSection,
  } = useContext(ScoreContext);

  const navigate = useNavigate();
  const section = "PhishingAssessment";

  const SIDEBAR_EXPANDED_WIDTH = 317;
  const SIDEBAR_COLLAPSED_WIDTH = 90;

  // ---- QUESTIONS ----
  const questions = [
  {
    questionId: 1,
    scenario: "Internal Survey / Feedback Form Phishing",
    question:
      'You receive an email that appears to be from the Admin Team, asking you to complete a "Year-End Workplace Feedback Form." The form requests your Employee ID, email password for verification, and system login ID.',
    image: q1, // optional
    options: [
      { value: "A", label: "Report the survey as suspicious because it asks for passwords" },
      { value: "B", label: "Provide only partial data, so the form doesn’t break" },
      { value: "C", label: "Fill in the details because internal surveys are routine" }, 
      { value: "D", label: "Forward it to a colleague asking if they filled it" },
    ],
    correctAnswer: "A",
    description:
      "This scenario tests your ability to identify credential harvesting attempts disguised as internal surveys.",
    recommendations:
      "Internal forms must never request passwords. Always report such emails to IT or Security teams.",
  },

  {
    questionId: 2,
    scenario: "Suspicious File-Sharing Link",
    question:
      'You receive a notification stating: "A confidential file has been shared with you." However, the link preview shows a non-corporate domain: http://googledrive-sharing-access.co/file123',
    image: q2,
    options: [
      { value: "A", label: "Open the file since it might contain important work data" },
      { value: "B", label: "Download the file using your mobile if the laptop seems risky" },
      { value: "C", label: "Verify with the sender through Teams or Chat before opening" },
      { value: "D", label: "Save the file to your desktop for later review" },
    ],
    correctAnswer: "C",
    description:
      "Attackers often spoof internal file-sharing tools using lookalike domains.",
    recommendations:
      "Always confirm file-sharing requests via official communication channels before opening links.",
  },

  {
    questionId: 3,
    scenario: "Fake Microsoft 365 Password Reset (Mobile Notification)",
    question:
      'A phone notification says: "Microsoft 365 Password Expires Today – Tap to Reset Now." The link opens a login page with the URL: http://securityfix@rnicrosoft.com',
    image: q3,
    options: [
      { value: "A", label: "Enter your username and password since it looks like Microsoft" },
      { value: "B", label: "Tap the link again to see if it corrects the URL" },
      { value: "C", label: "Screenshot the page and send your login ID to IT" },
      { value: "D", label: "Ignore the notification and reset the password via official M365 portal" },
    ],
    correctAnswer: "D",
    description:
      "Mobile phishing relies on small screens to hide malicious URLs.",
    recommendations:
      "Never reset passwords using links from notifications. Use official portals only.",
  },

  {
    questionId: 4,
    scenario: "Fake Vendor Invoice / Payment Change",
    question:
      'You receive an email from a known vendor titled "URGENT: Updated Payment Details – Process Today." A PDF invoice is attached, but the sender domain is slightly different from the actual vendor domain.',
    image: q4,
    options: [
      { value: "A", label: "Open the PDF and process the payment immediately" },
      { value: "B", label: "Verify the vendor via an official channel before acting" },
      { value: "C", label: "Reply to the email asking if the details are correct" },
      { value: "D", label: "Ignore the email completely" },
    ],
    correctAnswer: "B",
    description:
      "Payment redirection fraud is a common technique used in business email compromise attacks.",
    recommendations:
      "Always validate payment change requests using verified vendor contacts or portals.",
  },

  {
    questionId: 5,
    scenario: "Suspicious Mandatory Training Invite",
    question:
      'You receive a calendar invite for mandatory training from HR, but the organiser email does not match the official HR domain. The join link points to http://learning-secureportal.live',
    image: q5,
    options: [
      { value: "A", label: "Click the link because HR training is mandatory" },
      { value: "B", label: "Accept the invite but avoid clicking the link" },
      { value: "C", label: "Report the invite to HR or IT before taking action" },
      { value: "D", label: "Forward the invite to colleagues for confirmation" },
    ],
    correctAnswer: "C",
    description:
      "Fake training invites are often used to distribute malware or harvest credentials.",
    recommendations:
      "Only access training via verified HR platforms and trusted URLs.",
  },

  {
    questionId: 6,
    scenario: "Invoice Processing Failed – Callback Phishing",
    question:
      'You receive an email stating "Invoice Processing Failed – Call Support Immediately." The message asks you to call a phone number not listed in the official IT or Finance directory.',
    image: q6,
    options: [
      { value: "A", label: "Call the number immediately to avoid delays" },
      { value: "B", label: "Cross-check the number with official IT or Finance contacts" },
      { value: "C", label: "Ask a colleague to call the number for confirmation" },
      { value: "D", label: "Reply to the email requesting more details" },
    ],
    correctAnswer: "B",
    description:
      "Callback phishing uses fake support numbers to steal credentials or payment information.",
    recommendations:
      "Always verify phone numbers through official directories before making calls.",
  },
];

const handleDownloadCertificate = () => {
  const previewUrl = generatePhishingCertificate(
    userData,
    {
      totalQuestions: questions.length,
      correctAnswers: score,
      percentage: percentage, 
      answeredQuestions: answeredQuestions
    },
    susanLogo,
    true // previewMode = true
  );
  setCertificatePreviewUrl(previewUrl);
  setShowCertificateModal(true);
};



// 2. Download PDF from Modal
const handleActualDownload = () => {
  generatePhishingCertificate(
    userData,
    {
      totalQuestions: questions.length,
      correctAnswers: score,
      percentage: percentage,
      answeredQuestions: answeredQuestions
    },
    susanLogo,
    false, // previewMode = false
    'pdf'  // exportFormat = 'pdf'
  );
};


// 3. Open LinkedIn Modal
const handleShareLinkedIn = () => {
  setShowCertificateModal(false);
  setShowLinkedInModal(true);
};

// 4. Download as PNG (using html2canvas)
const downloadCertificateAsPNG = async () => {
  try {
    console.log('🎨 Starting PNG certificate generation...');
    
    setShowCertificateCanvas(true);
    await new Promise(resolve => setTimeout(resolve, 500));

    const canvas = document.getElementById('phishing-certificate-canvas');
    if (!canvas) {
      throw new Error('Certificate canvas not found');
    }

    const generatedCanvas = await html2canvas(canvas, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false
    });

    generatedCanvas.toBlob((blob) => {
      if (blob) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const userName = userData?.name || userData?.['cognito:username'] || 'Participant';
        const currentDate = new Date().toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });

        link.href = url;
        link.download = `Phishing_Certificate_${userName.replace(/\s+/g, "_")}_${currentDate.replace(/\s+/g, "_")}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        console.log('✅ PNG Certificate downloaded successfully!');
        setShowCertificateCanvas(false);
      }
    }, 'image/png', 1.0);

  } catch (error) {
    console.error('❌ PNG generation failed:', error);
    alert('Failed to generate PNG certificate. Please try again.');
    setShowCertificateCanvas(false);
  }
};

// 5. Open LinkedIn with Caption
// Combined PNG Download + LinkedIn Open Function
// ✅ Complete Button Handler with Auto-Caption
const downloadPNGAndOpenLinkedIn = async () => {
  try {
    console.log('🎨 Starting download & LinkedIn share...');
    
    // Step 1: Download PNG
    await downloadCertificateAsPNG();
    
    // Step 2: Wait 1.5 seconds then open LinkedIn with caption
    setTimeout(() => {
      const linkedInCaption = encodeURIComponent(
        `🔐 I'm happy to share that I've earned the Phishing Awareness Certification on the ServQual by SUSAN Platform after completing training and successfully passing the assessment with ${percentage}% score.

This certification covered phishing detection, social engineering risks, and best practices for preventing cyber threats.

#PhishingAwareness #Cybersecurity #InformationSecurity #Training #ServQual`
      );
      
      // ✅ LinkedIn URL with text parameter (DPDP jaisa)
      window.open(
        `https://www.linkedin.com/feed/?shareActive=true&text=${linkedInCaption}`, 
        '_blank', 
        'noopener,noreferrer'
      );
      
      setShowLinkedInModal(false);
    }, 1500);

  } catch (error) {
    console.error('❌ Error:', error);
  }
};



const handleDownloadReport = async () => {
  try {
    const assessmentData = {
      totalQuestions: questions.length,
      correctAnswers: score,
      percentage: percentage,
      questions: questions,
      selectedAnswers: selectedAnswers,
      answeredQuestions: answeredQuestions
    };

    // Generate PDF
    generatePhishingReport(userData, assessmentData , susanLogo);

    // Save report generation record to backend
    const reportData = {
      userId: userData["cognito:username"],
      userName: userData?.name || userData["cognito:username"],
      userEmail: userData?.email || "N/A",
      section: "PhishingAssessment",
      reportType: "Phishing Assessment Report",
      score: percentage,
      totalQuestions: questions.length,
      correctAnswers: score,
      generatedAt: new Date().toISOString(),
      status: percentage >= 60 ? "Pass" : "Fail"
    };

    const response = await fetch(
      "https://YOUR_API_ENDPOINT/save-report", 
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion()
        },
        body: JSON.stringify(reportData)
      }
    );

    if (!response.ok) {
      throw new Error("Failed to save report record");
    }

    console.log("Report download record saved successfully");
  } catch (error) {
    console.error("Error saving report:", error);
  }
};







  const getUserRegion = () => sessionStorage.getItem("userRegion") || "GB";

  const handleSidebarToggle = () => setIsSidebarCollapsed((prev) => !prev);

  useEffect(() => {
    localStorage.setItem("isSidebarCollapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  useEffect(() => {
    if (userData?.["cognito:username"]) {
      clearResponsesForSection(section);
      fetchResponsesForSection(userData["cognito:username"], section);
    }
  }, [userData, fetchResponsesForSection, clearResponsesForSection]);

  const handleStartAssessment = () => setCurrentStep(1);
  const handleSkipVideo = () => setCurrentStep(1);

  const handleBackToIntro = () => {
  setShowResults(false);
  setCurrentStep(0);          // Intro screen
  setCurrentQuestionIndex(0);
  setSelectedAnswers({});
  setActiveSection({});
};


  const handleAnswerSelect = (answer) => {
    const q = questions[currentQuestionIndex];
    const isCorrect = answer === q.correctAnswer;
    const value = isCorrect ? 1 : 0;

    setSelectedAnswers((prev) => ({ ...prev, [currentQuestionIndex]: answer }));

    updateResponses(section, q.questionId, {
      questionId: q.questionId,
      answer,
      isCorrect,
      questionText: q.question,
    });

    saveAllResponsesToBackend(userData["cognito:username"], section);

    updateScore(section, q.questionId, value, {
      question: q.question,
      correctAnswer: q.correctAnswer,
      explanation: q.explanation,
    });
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) setCurrentQuestionIndex((i) => i + 1);
    else setShowResults(true);
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) setCurrentQuestionIndex((i) => i - 1);
  };

  const handleCommentChange = (questionId, value) => {
    setComments((prev) => ({ ...prev, [questionId]: value }));
  };

  const postComment = async (questionId) => {
    const comment = comments[questionId];
    if (!comment || !comment.trim()) return;

    const commentData = {
      userId: userData["cognito:username"],
      section,
      questionId,
      comment,
    };

    setLoadingComments(true);
    try {
      const response = await fetch("https://di8iz5adw3.execute-api.ap-southeast-2.amazonaws.com/prod", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Region: getUserRegion(),
        },
        body: JSON.stringify(commentData),
      });
      if (!response.ok) throw new Error("Failed to post comment");
    } catch (err) {
      console.error("Error posting comment:", err);
    } finally {
      setLoadingComments(false);
    }
  };

  const showContent = (questionId, contentType) => {
    const key = `${questionId}-${contentType}`;
    setActiveSection((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const totalQuestions = questions.length;
  const answeredQuestions = Object.keys(selectedAnswers).length;
  const progress = totalQuestions ? Math.round((answeredQuestions / totalQuestions) * 100) : 0;

  const score = Object.entries(selectedAnswers).reduce((acc, [idx, ans]) => {
    const q = questions[Number(idx)];
    return acc + (q && ans === q.correctAnswer ? 1 : 0);
  }, 0);
  const percentage = totalQuestions ? Math.round((score / totalQuestions) * 100) : 0;

  const currentQuestion = questions[currentQuestionIndex];

  // Sidebar width calc like OTIoTSecurity
  const sidebarWidth = isSidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH;
const slides = [slide1, slide2, slide3, slide4,slide5];


const [currentSlide, setCurrentSlide] = useState(0);
const handleNextSlide = () => {
  setCurrentSlide((prev) =>
    prev < slides.length - 1 ? prev + 1 : prev
  );
};

const handlePrevSlide = () => {
  setCurrentSlide((prev) =>
    prev > 0 ? prev - 1 : prev
  );
};

const [showImageModal, setShowImageModal] = useState(false);
const [selectedImage, setSelectedImage] = useState(null);

// Handler functions
const handleViewImage = (imageSrc) => {
  setSelectedImage(imageSrc);
  setShowImageModal(true);
};

const handleCloseModal = () => {
  setShowImageModal(false);
  setSelectedImage(null);
};



  return (
    <>
      <div>
        <Row className="g-0">
          {/* Sidebar */}
         <Col
                 xs={12}
                 className={`bg-transparent sidebar-container ${isSidebarCollapsed ? "collapsed" : "hello"}`}
                 style={{
                   width: isSidebarCollapsed ? "90px" : "317px",
                   transition: "width 0.3s ease",
                 }} 
               >
                 <Menubar
                   isCollapsed={isSidebarCollapsed}
                   onToggle={handleSidebarToggle}
                 />
      </Col> 

          {/* Main content */}
          <Col
            className="pt-0 px-0 ps-0 section-container"
            style={{
              width: `calc(100% - ${sidebarWidth}px)`,
              transition: "width 0.3s ease", 
            }}
          >
            <NavigationBar userData={userData} isSidebarCollapsed={isSidebarCollapsed} />

            {/* Sticky progress (only after start) */}
            {currentStep !== 0 && (
              <div className="sticky-top bg-white" style={{ top: "50px", zIndex: 999 }}>
                <div style={{ position: "relative" }}>
                  <ProgressBar
                    now={progress}
                    className="custom-progress-bar"
                    style={{ height: "20px", margin: "0px 10px 10px 10px" }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "50%",
                      transform: "translateX(-50%)",
                      color: "#000",
                    }}
                  >
                    {`${progress}%`}
                  </span>
                </div>
              </div>
            )}

            {/* Scrollable content area */}
            <Col className="overflow-auto p-4">
              {/* INTRO SCREEN */}
              {currentStep === 0 && (
                <Row className="justify-content-center">
                  <Col xs={12} >
<Card className="iam-card iam-card-intro text-center">
                      <Card.Body>
                        <h2> Phishing Awareness & Assessment </h2>
                        <p>Learn to identify and prevent phishing attacks.</p>

  <div className="ppt-slide-wrapper">
  <img
    src={slides[currentSlide]}
    alt={`Slide ${currentSlide + 1}`}
    className="ppt-slide-image"
  />
</div>

  {/* Slide Controls */}
  <div className="ppt-controls">
    <Button
      variant="outline-secondary"
      onClick={handlePrevSlide}
      disabled={currentSlide === 0}
    >
      Previous
    </Button>

    <span className="ppt-indicator">
      {currentSlide + 1} / {slides.length}
    </span>

    <Button
      variant="outline-primary"
      onClick={handleNextSlide}
      disabled={currentSlide === slides.length - 1}
    >
      Next
    </Button>
  </div>

                        <p className="text-muted mt-3">
                          {/* Review the training slides or proceed directly to the assessment. */}
                          Please review all training slides to start the assessment.

                        </p>

                        <div className="d-flex justify-content-center gap-3 mt-3">
                          <Button variant="outline-secondary" onClick={handleSkipVideo}>
                            Skip Training
                          </Button>
                          <Button
  variant="primary"
  onClick={handleStartAssessment}
  disabled={currentSlide !== slides.length - 1}
>
  Start Assessment
</Button>

{/* {currentSlide !== slides.length - 1 && (
  <small className="text-muted d-block mt-2">
    Please review all training slides to start the assessment.
  </small>
)} */}

                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}

            {/* QUESTIONS / RESULTS */}
{currentStep !== 0 && (
  <Row className="justify-content-center">
    
    <Col xs={12}>
      <h4 className="mb-3">Phishing Awareness & Assessment</h4>
       {!showResults && (
  <div className="result-action1">
    <Button variant="primary" onClick={handleBackToIntro}>
     Back to Training
    </Button>
  </div>
)}


      <Card className="iam-card">
        
        <Card.Body>

         {/* ===== HEADER ONLY WHEN QUESTIONS ARE SHOWN ===== */}
{/* HEADER ONLY WHEN QUESTIONS ARE SHOWN */}
{!showResults && (
  <div className="assessment-header-new mb-4">
    <div className="question-chip-inline">
      Question <strong>{currentQuestionIndex + 1}</strong> of <strong>{questions.length}</strong>
    </div>
    <div className="answered-badge-inline">
      Answered {answeredQuestions}/{totalQuestions}
    </div>
  </div>
)}


          {/* ===== ATTRACTIVE HEADER END ===== */}

          {!showResults && (
            <>
              {/* Scenario Section */}
             {/* Scenario Section */}
<Row className="mb-4">
  <Col xs={12} lg={7}>
    <div className="scenario-box">
      <span className="scenario-label">Scenario</span>
      <h5 className="scenario-title">{currentQuestion.scenario}</h5>
      <p className="scenario-text">{currentQuestion.question}</p>
      
      {/* View Image Button */}
      {currentQuestion.image && (
        <Button 
          variant="outline-primary" 
          size="sm"
          onClick={() => handleViewImage(currentQuestion.image)}
          className="view-image-btn "
        >
          <i className="bi bi-image me-2 "></i>
          View Sample Image
        </Button>
      )}
    </div>
  </Col>

  {/* <Col xs={12} lg={5} className="text-center">
    {currentQuestion.image && (
      <div className="scenario-image-card">
        <img
          src={currentQuestion.image}
          alt={currentQuestion.scenario}
          className="img-fluid"
        />
      </div>
    )}
  </Col> */}
</Row>
{/* Image Modal */}
{/* Image Modal - Simple Close Button */}
{showImageModal && (
  <div className="image-modal-overlay" onClick={handleCloseModal}>
    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
      <img src={selectedImage} alt="Phishing Example" className="modal-image" />
      <button className="image-modal-close-simple" onClick={handleCloseModal}>
        ✕
      </button>
    </div>
  </div>
)}


              {/* Options Section */}
              <Row className="mb-4">
                {currentQuestion.options.map((opt) => {
                  const isSelected =
                    selectedAnswers[currentQuestionIndex] === opt.value;

                  return (
                    <Col xs={12} key={opt.value} className="mb-3">
                      <div
                        className={`option-tile ${
                          isSelected ? "active" : ""
                        }`}
                        onClick={() =>
                          handleAnswerSelect(opt.value)
                        }
                      >
                        <div className="option-key">{opt.value}</div>
                        <div className="option-content">
                          {opt.label}
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>

              {/* Info + Comments */}
              {/* <Row className="mt-4">
                <Col xs={12}>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <button
    className={`buttonI ${activeTab === "desc" ? "active" : ""}`}
    onClick={() =>  handleTabClick("desc")}
  >
    Description
  </button>

                    <button
    className={`buttonI ${activeTab === "reco" ? "active" : ""}`}
    onClick={() => handleTabClick("reco")}
  >
    Recommendations
  </button>
                     <button
    className={`buttonI ${activeTab === "comment" ? "active" : ""}`}
    onClick={() => handleTabClick("comment")}
  >
    Comment
  </button>
</div>
                </Col>

                <Col xs={12} lg={7}>
                  {activeTab === "desc" && (
  <div className="content">
    <h6>Description</h6>
    <p className="mb-0">{currentQuestion.description}</p>
  </div>
)}

                 {activeTab === "reco" && (
  <div className="content">
    <h6>Recommendations</h6>
    <p className="mb-0">{currentQuestion.recommendations}</p>
  </div>
)}
                </Col>

                <Col xs={12} lg={7}>
                  {activeTab === "comment" && (
  <div className="comment-card">
    <Form.Label className="fw-semibold mb-2">
      Comments
    </Form.Label>

    <Form.Control
      as="textarea"
      rows={4}
      placeholder="Add your comment here..."
      value={comments[currentQuestion.questionId] || ""}
      onChange={(e) =>
        handleCommentChange(
          currentQuestion.questionId,
          e.target.value
        )
      }
    />

    <div className="d-flex justify-content-end mt-2">
      <button
        className="Postbtn"
        onClick={() => postComment(currentQuestion.questionId)}
      >
        Post
      </button>
    </div>
  </div>
)}
                </Col>
              </Row> */}

              {/* Navigation */}
              <Row className="mt-4">
                <Col xs={6}>
                  <Button
                    variant="outline-secondary"
                    onClick={handlePrevious}
                    disabled={currentQuestionIndex === 0}
                  >
                    Previous
                  </Button> 
                </Col>

                <Col xs={6} className="text-end">
                  <Button
                    variant="primary"
                    onClick={handleNext}
                  >
                    {currentQuestionIndex ===
                    questions.length - 1
                      ? "Finish Assessment"
                      : "Next Question"}
                  </Button>
                </Col>
              </Row>
            </>
          )}

        {showResults && (
  <Col xs={12}>
    <div className="phishing-result-card">
      {/* Animated Header with Confetti Effect */}
      <div className="result-header-animated">
        <div className={`status-badge-modern ${percentage >= 60 ? 'badge-success' : 'badge-warning'}`}>
          {percentage >= 80 ? ' Excellent!' : percentage >= 60 ? ' Good Job!' : ' Needs Improvement'}
        </div>
        <h2 className="result-title-gradient">Assessment Complete</h2>
        <p className="result-subtitle">Review your performance summary below</p>
      </div> 

      {/* Main Content */}
      <Row className="align-items-center justify-content-center mt-4">
        {/* Animated Circular Progress */}
        <Col xs={12} md={5} className="text-center mb-4 mb-md-0">
          <div className="circular-progress-container">
<svg className="progress-ring" width={320} height={320}>
              <defs>
                <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor: percentage >= 60 ? '#10b981' : '#f59e0b'}} />
                  <stop offset="100%" style={{stopColor: percentage >= 60 ? '#059669' : '#d97706'}} />
                </linearGradient>
              </defs>
              {/* Background Circle */}
              {/* Background Circle */}
<circle className="progress-ring-bg" cx={160} cy={160} r={140} fill="none" stroke="#e5e7eb" strokeWidth={16} />

{/* Progress Circle */}
<circle
  className="progress-ring-circle"
  cx={160}
  cy={160}
  r={140}
  fill="none"
  stroke="url(#progressGradient)"
  strokeWidth={16}
  strokeLinecap="round"
  style={{
    strokeDasharray: `${2 * Math.PI * 140}`,
    strokeDashoffset: `${2 * Math.PI * 140 * (1 - percentage / 100)}`,

                  transform: 'rotate(-90deg)',
                  transformOrigin: '50% 50%',
                  transition: 'stroke-dashoffset 1.5s ease-out'
                }}
              />
            </svg>
            
            {/* Center Content */}
            <div className="progress-center-content">
              <div className="score-percentage-large">{percentage}%</div>
              <div className="score-label-text">Final Score</div>
              <div className={`performance-badge ${percentage >= 80 ? 'badge-excellent' : percentage >= 60 ? 'badge-good' : 'badge-needs-work'}`}>
                {percentage >= 80 ? 'Excellent' : percentage >= 60 ? 'Good' : 'Average'}
              </div>
            </div>
          </div>
        </Col>

        {/* Stats Cards */}
        <Col xs={12} md={7}>
          <div className="stats-grid">
            <div className="stat-card stat-card-blue">
              <div className="stat-content">
                <div className="stat-label">Total Questions</div>
                <div className="stat-value">{totalQuestions}</div>
              </div>
            </div>

            <div className="stat-card stat-card-green">
              <div className="stat-content">
                <div className="stat-label">Correct Answers</div>
                <div className="stat-value">{score}</div>
              </div>
            </div>

            <div className="stat-card stat-card-orange">
              <div className="stat-content">
                <div className="stat-label">Incorrect</div>
                <div className="stat-value">{answeredQuestions - score}</div>
              </div>
            </div>

            <div className="stat-card stat-card-purple">
              <div className="stat-content">
                <div className="stat-label">Answered</div>
                <div className="stat-value">{answeredQuestions}</div>
              </div>
            </div>
          </div>

          {/* Performance Message */}
          <div className={`performance-message ${percentage >= 60 ? 'message-success' : 'message-warning'}`}>
            {percentage >= 80 ? (
              <>
                <strong>🎯 Outstanding Performance!</strong>
                <p>You demonstrate excellent phishing awareness. Keep up the great work!</p>
              </>
            ) : percentage >= 60 ? (
              <>
                <strong>👍 Good Work!</strong>
                <p>You're on the right track. Review missed questions to strengthen your skills.</p>
              </>
            ) : (
              <>
                <strong>📚 Keep Learning!</strong>
                <p>We recommend revisiting the training material to improve your awareness.</p>
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* Action Buttons */}
      <div className="result-actions">
        <Button
          variant="outline-primary"
          onClick={handleBackToIntro}
          className="btn-result-action"
        >
          <span>↩️</span> Return to Training
        </Button>
        
        <Button
          variant="success"
          onClick={handleDownloadReport}
          className="btn-result-download"
        >
          <span>📥</span> Download Report
        </Button>
        {/* Certificate Button - Only if 70%+ */}
  {percentage >= 70 && (
    <Button 
      variant="warning" 
      onClick={handleDownloadCertificate}
      className="btn-result-certificate"
    >
      <span>🏆</span> View Certificate 
    </Button>
  )}
      </div>
    </div>
  </Col>
)}

      </Card.Body>
      </Card>
    </Col>
  </Row>
)}
            </Col>
            

            <BackgroundFooter isSidebarCollapsed={isSidebarCollapsed} />
          </Col>
        </Row>


      {/* ===== MODAL 1: CERTIFICATE PREVIEW ===== */}
<Modal 
  show={showCertificateModal} 
  onHide={() => setShowCertificateModal(false)}
  size="xl"
  centered
  backdrop="static"
>
<Modal.Header
  closeButton
  style={{
    filter: "invert(1) brightness(0)",
    opacity: 1
  }}
>    <Modal.Title>🎓 Phishing Certificate Preview</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ textAlign: 'center', padding: '20px' }}>
    {certificatePreviewUrl ? (
      <embed 
        src={certificatePreviewUrl} 
        type="application/pdf"
        width="100%"
        height="600px"
        style={{ border: '2px solid #ddd', borderRadius: '8px' }}
      />
    ) : (
      <Spinner animation="border" />
    )}
  </Modal.Body>
  <Modal.Footer style={{ justifyContent: 'space-between' }}>
    <Button variant="success" onClick={handleActualDownload}>
      📥 Download Certificate as PDF
    </Button>
    <Button variant="primary" onClick={handleShareLinkedIn}>
      🔗 Share on LinkedIn
    </Button>
  </Modal.Footer>
</Modal>




{/* ===== MODAL 2: SHARE ON LINKEDIN (Updated Design) ===== */}
<Modal 
  show={showLinkedInModal} 
  onHide={() => setShowLinkedInModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton style={{ backgroundColor: '#0077b5', color: 'white' }}>
    <Modal.Title>
      <i className="bi bi-linkedin"></i> Share on LinkedIn
    </Modal.Title>
  </Modal.Header>
  
  <Modal.Body style={{ padding: '30px', backgroundColor: '#f8f9fa' }}>
    
    {/* Success Message */}
    {showCertificateCanvas && (
      <div style={{
        textAlign: 'center',
        backgroundColor: '#d4edda',
        border: '1px solid #c3e6cb',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '10px' }}>✅</div>
        <h4 style={{ color: '#155724', marginBottom: '5px' }}>Certificate Downloaded as PNG!</h4>
        <p style={{ color: '#155724', fontSize: '14px', margin: 0 }}>
          Check your Downloads folder for the certificate image
        </p>
      </div>
    )}

    {/* Quick Steps Box */}
   {/* Quick Steps Box - Updated */}
<div style={{
  border: '2px dashed #dee2e6',
  borderRadius: '8px',
  padding: '20px',
  backgroundColor: 'white',
  marginBottom: '20px'
}}>
  <h6 style={{ color: '#dc3545', marginBottom: '15px' }}>
    📋 Quick Steps to Share:
  </h6>
  <ol style={{ paddingLeft: '20px', margin: 0, fontSize: '14px', lineHeight: '2' }}>
    <li>Click <strong>"Download PNG & Open LinkedIn"</strong> button below</li>
    <li>Certificate will download as PNG image</li>
    <li>LinkedIn will open automatically in a new tab</li>
    <li>Click <strong>"Add media"</strong> 📎 and select the downloaded PNG</li>
    <li>Review and click <strong>"Post"</strong> 🚀</li>
  </ol> 
</div>


  </Modal.Body>
 <Modal.Footer style={{ borderTop: 'none', justifyContent: 'center', padding: '20px' }}>
  <Button 
    variant="outline-secondary" 
    onClick={() => setShowLinkedInModal(false)}
    style={{ minWidth: '150px', fontWeight: '600' }}
  >
    Close
  </Button>
  
  <Button 
    variant="primary"
    onClick={async () => {
      console.log('🚀 Starting download & LinkedIn share...');
      
      // Step 1: Download PNG
      await downloadCertificateAsPNG();
      
      // Step 2: Open LinkedIn with auto-caption
      setTimeout(() => {
        const linkedInCaption = encodeURIComponent(
          `🔐 I'm happy to share that I've earned the Phishing Awareness Certification on the ServQual by SUSAN Platform after completing training and successfully passing the assessment with ${percentage}% score.

This certification covered phishing detection, social engineering risks, and best practices for preventing cyber threats.

#PhishingAwareness #Cybersecurity #InformationSecurity #Training #ServQual`
        );
        
        window.open(
          `https://www.linkedin.com/feed/?shareActive=true&text=${linkedInCaption}`, 
          '_blank', 
          'noopener,noreferrer'
        );
        
        setShowLinkedInModal(false);
      }, 1500);
    }}
  >
    <i className="fab fa-linkedin" style={{marginRight:"10px"}}></i>
    Download PNG & Open LinkedIn
  </Button>
</Modal.Footer>

</Modal>


{/* ===== HIDDEN CANVAS FOR PNG GENERATION ===== */}
{showCertificateCanvas && (
  <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
    <div 
      id="phishing-certificate-canvas"
      style={{
        width: '1754px',
        height: '1240px',
        backgroundColor: '#ffffff',
        padding: '0',
        margin: '0',
        position: 'relative',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        overflow: 'hidden'
      }}
    >
      {/* Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff'
      }}></div>

      {/* Outer Border */}
      <div style={{
        position: 'absolute',
        top: '59px',
        left: '59px',
        right: '59px',
        bottom: '59px',
        border: '8.85px solid #061c31'
      }}></div>
      
      {/* Inner Border */}
      <div style={{
        position: 'absolute',
        top: '77px',
        left: '77px',
        right: '77px',
        bottom: '77px',
        border: '1.77px solid #061c31'
      }}></div>

      {/* Top Left Triangle */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        borderLeft: '295px solid #061c31',
        borderBottom: '295px solid transparent'
      }}></div>

      {/* Bottom Right Triangle */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderRight: '295px solid #061c31',
        borderTop: '295px solid transparent'
      }}></div>

      {/* Logo */}
      <div style={{
        position: 'absolute',
        top: '106px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center'
      }}>
        <img 
          src={susanLogo} 
          alt="Logo" 
          style={{ 
            height: '147.5px',
            width: 'auto'
          }} 
        />
      </div>

      {/* CERTIFICATE */}
      <div style={{
        position: 'absolute',
        top: '300px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '100%'
      }}>
        <div style={{ 
          fontSize: '120px',
          fontWeight: 'bold',
          color: '#061c31',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          letterSpacing: '4px',
          lineHeight: '1'
        }}>
          CERTIFICATE
        </div>
      </div>

      {/* OF ACHIEVEMENT */}
      <div style={{
        position: 'absolute',
        top: '430px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '100%'
      }}>
        <div style={{ 
          fontSize: '48px',
          fontWeight: 'normal',
          color: '#000000',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          letterSpacing: '3px',
          lineHeight: '1'
        }}>
          OF ACHIEVEMENT
        </div>
      </div>

      {/* This is to certify that */}
      <div style={{
        position: 'absolute',
        top: '500px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '100%'
      }}>
        <div style={{ 
          fontSize: '34px',
          fontStyle: 'italic',
          color: '#000000',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          This is to certify that
        </div>
      </div>

      {/* User Name */}
      <div style={{
        position: 'absolute',
        top: '555px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '100%'
      }}>
        <div style={{ 
          fontSize: '100px',
          fontWeight: 'bold',
          color: '#061c31',
          margin: 0,
          textTransform: 'uppercase',
          fontFamily: 'Helvetica, Arial, sans-serif',
          borderBottom: '3px solid #061c31',
          display: 'inline-block',
          paddingBottom: '8px',
          letterSpacing: '2px',
          lineHeight: '1'
        }}>
          {userData?.name || userData?.['cognito:username'] || 'PARTICIPANT'}
        </div>
      </div>

      {/* has successfully completed the */}
      <div style={{
        position: 'absolute',
        top: '695px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '90%'
      }}>
        <div style={{ 
          fontSize: '30px',
          color: '#000000',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          has successfully completed the
        </div>
      </div>

      {/* Phishing Awareness Training & Assessment */}
      <div style={{
        position: 'absolute',
        top: '738px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '90%'
      }}>
        <div style={{ 
          fontSize: '44px',
          fontWeight: 'bold',
          color: '#061c31',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1.1'
        }}>
          Phishing Awareness Training & Assessment
        </div>
      </div>

      {/* and demonstrated excellent knowledge */}
      <div style={{
        position: 'absolute',
        top: '800px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '90%'
      }}>
        <div style={{ 
          fontSize: '28px',
          color: '#000000',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          and demonstrated excellent knowledge in identifying cyber threats
        </div>
      </div>

      {/* Green Score Box */}
      <div style={{
        position: 'absolute',
        top: '850px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '320px',
        height: '90px',
        backgroundColor: '#33a148',
        border: '3px solid #061c31',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ 
          fontSize: '50px',
          fontWeight: 'bold',
          color: '#ffffff',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          {percentage}%
        </div>
        <div style={{ 
          fontSize: '22px',
          color: '#ffffff',
          margin: 0,
          marginTop: '4px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          FINAL SCORE
        </div>
      </div>

      {/* Total Questions & Correct Answers */}
      <div style={{
        position: 'absolute',
        top: '970px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '90%'
      }}>
        <div style={{ 
          fontSize: '24px',
          color: '#333333',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1.3'
        }}>
          <strong>Total Questions:</strong> {questions.length} | <strong>Correct Answers:</strong> {score}
        </div>
      </div>

      {/* Date of Completion */}
      <div style={{
        position: 'absolute',
        top: '1005px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '90%'
      }}>
        <div style={{ 
          fontSize: '24px',
          color: '#333333',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          <strong>Date of Completion:</strong> {new Date().toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric"
          })}
        </div>
      </div>

      {/* Certificate ID */}
      <div style={{
        position: 'absolute',
        top: '1040px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '90%'
      }}>
        <div style={{ 
          fontSize: '18px',
          color: '#808080',
          margin: 0,
          fontFamily: 'Courier, monospace',
          lineHeight: '1'
        }}>
          Certificate ID: PHISH-{Date.now()}-{Math.random().toString(36).substr(2,6).toUpperCase()}
        </div>
      </div>
          {/* ✅ RIGHT SIDE - Issued by ServQual Limited */}
      <div style={{
        position: 'absolute',
        top: '1050px',          
        right: '220px',          
        textAlign: 'center'
      }}>
        <div style={{ 
          fontSize: '22px',
          color: '#000000',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1.4'
        }}>
          <div style={{ fontSize: '18px', fontWeight: 'normal' }}>Issued by</div>
          <div style={{ fontSize: '22px', fontWeight: 'bold', marginTop: '5px' }}>ServQual Limited</div>
        </div>
      </div>



             {/* Footer - Company Name */}
      <div style={{
        position: 'absolute',
        top: '1100px',        
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '100%'
      }}>
        <div style={{ 
          fontSize: '22px',
          fontWeight: 'bold',
          color: '#061c31',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          ServQual | Cyber Security, Gen AI Risk & Cloud Security Solutions
        </div>
      </div>

      {/* Footer - Website */}
      <div style={{
        position: 'absolute',
        top: '1130px',        
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        width: '100%'
      }}>
        <div style={{ 
          fontSize: '18px',
          color: '#808080',
          margin: 0,
          fontFamily: 'Helvetica, Arial, sans-serif',
          lineHeight: '1'
        }}>
          https://srql.com
        </div>
      </div>

    </div>
  </div>
)}



      </div>
    </>
  );
};

export default PhishingAssessmentModule;